import { useTranslation } from 'react-i18next'

import { Text, VStack } from '@enechain/ecloud-designsystem'

import { useMemberDisplayName } from '~/hooks/member/useMemberDisplayName'
import { formatCivilDateSlash } from '~/models/civilDate'
import { formatJstDateTimeHm } from '~/models/dateTime'
import {
  FormGrid,
  ReadOnlyRow,
} from '~/pages/CustomerInfo/components/FormField'
import { FormModalShell } from '~/pages/CustomerInfo/components/FormModalShell'
import { VoltageBadges } from '~/pages/CustomerInfo/components/VoltageBadges'
import { formatKwDecimal } from '~/pages/CustomerInfo/models/display'
import type { SupplyPoint } from '~/pages/CustomerInfo/models/types'

type Props = {
  point: SupplyPoint
  onClose: () => void
}

/** 失注の地点の閲覧。 編集・削除・契約への切り替えはできないので入力欄にせず文で出す。 */
export const LostPointModal = ({
  point,
  onClose,
}: Props): React.ReactElement => {
  const { t } = useTranslation()
  const none = t('page:customerInfo.common.none')
  const resolveMemberName = useMemberDisplayName()
  return (
    <FormModalShell
      errorMessage={undefined}
      isDirty={false}
      isPending={false}
      isReadOnly
      onClose={onClose}
      title={t('page:customerInfo.modal.editTitle')}
    >
      <VStack align="stretch" gap={3}>
        <FormGrid>
          <ReadOnlyRow label={t('page:customerInfo.form.customerName')}>
            {point.customerName}
          </ReadOnlyRow>
          <ReadOnlyRow label={t('page:customerInfo.form.supplyPointNumber')}>
            {point.supplyPointNumber ?? t('page:customerInfo.common.undecided')}
          </ReadOnlyRow>
          <ReadOnlyRow label={t('page:customerInfo.form.voltage')}>
            <VoltageBadges voltages={[point.voltageClass]} />
          </ReadOnlyRow>
          <ReadOnlyRow label={t('page:customerInfo.form.contractKw')}>
            {formatKwDecimal(point.contractKw)}
          </ReadOnlyRow>
          <ReadOnlyRow label={t('page:customerInfo.contract.column.start')}>
            {formatCivilDateSlash(point.supplyStartDate)} 〜{' '}
            {point.supplyEndDate === undefined
              ? none
              : formatCivilDateSlash(point.supplyEndDate)}
          </ReadOnlyRow>
        </FormGrid>
        <Text color="Text.midEmphasis" fontSize="sm">
          {t('page:customerInfo.note.lost', {
            at:
              point.lostAt === undefined
                ? none
                : formatJstDateTimeHm(point.lostAt),
            by: resolveMemberName(point.lostBy) ?? none,
          })}
        </Text>
      </VStack>
    </FormModalShell>
  )
}
